import { ErrorBoundary } from '@sentry/nextjs';
import { isNumber } from 'lodash';

import { InternalServerErrorPageView } from '../views/internal-server-error-page-view';
import { NotFoundErrorPageView } from '../views/not-found-error-page-view';

export function PageErrorBoundary({
  children,
  errorCode
}: {
  children: React.ReactNode;
  errorCode?: number;
}) {
  const errorComponents: Record<number, React.ReactNode> = {
    500: <InternalServerErrorPageView />,
    404: <NotFoundErrorPageView />
  };

  return (
    <ErrorBoundary fallback={<InternalServerErrorPageView />}>
      {isNumber(errorCode)
        ? errorComponents[errorCode] || <InternalServerErrorPageView />
        : children}
    </ErrorBoundary>
  );
}
